module.exports = __webpack_public_path__ + "static/media/bg-photo-1@2x.5bdaed17.png";